export default __webpack_public_path__ + "static/media/mc_lid_close.6f198843.svg";